import React from 'react';
import { ColumnType } from 'antd/es/table';
import { RiskMaintenanceTableRow } from 'store/ducks/Reporting/types';

const getUniqueValues = (
  data: RiskMaintenanceTableRow[],
  field: keyof RiskMaintenanceTableRow
) => {
  return Array.from(
    new Set(
      data
        .map((item) => item[field])
        .filter(
          (value) => value !== null && value !== undefined && value !== ''
        )
        .map(String)
    )
  );
};

const getFilterColumn = (
  data: RiskMaintenanceTableRow[],
  dataIndex: keyof RiskMaintenanceTableRow,
  title: string,
  width = 140
): ColumnType<RiskMaintenanceTableRow> => {
  const values = getUniqueValues(data, dataIndex);

  return {
    title,
    dataIndex,
    key: dataIndex,
    width,

    filters: values.map((value) => ({
      text: value,
      value
    })),

    filterSearch: true,

    onFilter: (value, record) => {
      const recordValue = record[dataIndex];

      return String(recordValue ?? '') === String(value);
    },

    render: (value) => value ?? '-'
  };
};

const getColumn = (
  dataIndex: keyof RiskMaintenanceTableRow,
  title: string,
  width = 140
): ColumnType<RiskMaintenanceTableRow> => ({
  title,
  dataIndex,
  key: dataIndex,
  width,
  render: (value) => value ?? '-'
});

export const processRiskMaintenanceColumns = (
  data: RiskMaintenanceTableRow[] = []
): ColumnType<RiskMaintenanceTableRow>[] => {
  const hasValue = (field: keyof RiskMaintenanceTableRow) =>
    data.some(
      (item) =>
        item[field] !== null && item[field] !== undefined && item[field] !== ''
    );

  const columns: ColumnType<RiskMaintenanceTableRow>[] = [
    getFilterColumn(data, 'risk_title', 'Risk'),
    getColumn('description', 'Description'),
    getColumn('risk_owner', 'Risk Owner'),
    getColumn('key_risk_indicators', 'Key Risk Indicators'),
    getFilterColumn(data, 'category', 'Category', 120),
    getFilterColumn(data, 'severity_name', 'Severity', 120),
    getFilterColumn(data, 'risk_status_name', 'Risk Status', 120),

    getColumn('risk_assessment_score', 'Risk Assessment Score', 120),

    getColumn('assessment_date', 'Assessment Date', 120)
  ];

  const organizationColumns: ColumnType<RiskMaintenanceTableRow>[] = [
    getFilterColumn(data, 'group_name', 'Group'),
    getFilterColumn(data, 'division_name', 'Division'),
    getFilterColumn(data, 'region_name', 'Region'),
    getFilterColumn(data, 'legal_entity_name', 'Legal Entity'),
    getFilterColumn(data, 'business_unit_name', 'Business Unit')
  ];

  const visibleOrganizationColumns = organizationColumns.filter(
    (column) =>
      typeof column.dataIndex === 'string' &&
      hasValue(column.dataIndex as keyof RiskMaintenanceTableRow)
  );

  return [...visibleOrganizationColumns, ...columns];
};
